/* SOLE F63 info page — product gallery: swap the main image when a thumbnail is chosen.
   Progressive enhancement: with JS off, the main image + all thumbs still render. */
(function () {
  function initGallery(root) {
    var main = root.querySelector('#f63-gallery-main');
    var thumbs = root.querySelectorAll('.f63-gallery__thumb');
    var status = root.querySelector('#f63-gallery-status');
    if (!main || !thumbs.length) return;

    function select(btn) {
      var full = btn.getAttribute('data-full');
      var alt = btn.getAttribute('data-alt') || '';
      if (full) { main.src = full; main.alt = alt; }
      thumbs.forEach(function (t) {
        var on = t === btn;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      // announce the change without moving focus out of the thumbnail strip
      if (status && alt) { status.textContent = 'Showing image: ' + alt; }
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { select(btn); });
    });
  }

  /* Big, obvious play button overlaid on the video poster. Native <video controls> still works;
     this just makes "play" unmissable. Hides once the video starts. */
  function initVideo(frame) {
    var video = frame.querySelector('video');
    if (!video || frame.querySelector('.f63-video__play')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'f63-video__play';
    btn.setAttribute('aria-label', 'Play video');
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z"/></svg>';
    frame.appendChild(btn);
    btn.addEventListener('click', function () { video.play(); });
    video.addEventListener('play', function () { btn.hidden = true; });
    video.addEventListener('ended', function () { btn.hidden = false; });
  }

  function init() {
    document.querySelectorAll('[data-f63-gallery]').forEach(initGallery);
    document.querySelectorAll('.f63-video__frame').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
